import a from "./component-library224.js";
/* empty css                     */
import i from "./component-library98.js";
var l = function() {
  var t = this, n = t._self._c, e = t._self._setupProxy;
  return n("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: e.openable.onClickaway, expression: "openable.onClickaway" }], staticClass: "dropdown", class: e.containerClass }, [t._t("trigger", function() {
    return [n(e.LinkButton, { ref: "buttonElement", staticClass: "dropdown__button", attrs: { id: `dropdown${e.uid}`, tag: "button", type: "button", outline: "", "small-padding": "", "is-wide": "", role: t.role, "aria-controls": `dropdown-list${e.uid}`, "aria-haspopup": t.ariaHasPopup, "aria-expanded": e.openable.isOpened.value ? "true" : "false", "aria-label": t.label, disabled: t.disabled }, on: { click: function(o) {
      return o.preventDefault(), e.openable.toggle.apply(null, arguments);
    } } }, [n("span", { staticClass: "dropdown__button-caption" }, [t._t("captionBefore"), t._t("caption", function() {
      return [t._v(" " + t._s(t.caption) + " ")];
    })], 2), n(e.Arrow, { staticClass: "dropdown__icon", attrs: { "aria-hidden": "true", direction: e.openable.isOpened.value ? "top" : "bottom", tag: "span" } })], 1)];
  }, { openable: e.openable, disabled: t.disabled, elementId: `dropdown${e.uid}`, uid: e.uid, open: e.openable.open, close: e.openable.close, toggle: e.openable.toggle }), n("div", { ref: "announcementElement", staticStyle: { opacity: "0", position: "absolute" }, attrs: { role: "status", "aria-live": "polite" } }), n(e.DropdownContainer, { directives: [{ name: "show", rawName: "v-show", value: e.openable.isOpened.value, expression: "openable.isOpened.value" }], ref: "dropdownContainerElement", attrs: { uid: e.uid, "is-multi-select": t.isMultiSelect, "auto-width": t.autoWidth, "show-right": e.showRight }, scopedSlots: t._u([{ key: "default", fn: function() {
    return [t._t("default", null, { uid: e.uid, openable: e.openable })];
  }, proxy: !0 }, { key: "submit", fn: function() {
    return [t._t("submit", null, { uid: e.uid, openable: e.openable })];
  }, proxy: !0 }, { key: "input", fn: function() {
    return [t._t("input", null, { uid: e.uid, openable: e.openable })];
  }, proxy: !0 }], null, !0) })], 2);
}, r = [], s = /* @__PURE__ */ i(
  a,
  l,
  r,
  !1,
  null,
  "e00240c1"
);
const b = s.exports;
export {
  b as default
};
